import { graphql } from "gql";

const EDIT_DISTRIBUTION_GROUP_SEEN_MUTATION = graphql(`
  mutation EditDistributionGroupSeen($id: ID!, $isSeen: Boolean!) {
    editDistributionGroup(id: $id, input: { isSeen: $isSeen }) {
      id
      isUnseen
    }
  }
`);

export default EDIT_DISTRIBUTION_GROUP_SEEN_MUTATION;
